// extracted by mini-css-extract-plugin
export default {"card":"sUFG3wHF","neutral":"ikLpWZZG","positive":"ihhX_IuW"};